export default __webpack_public_path__ + "static/media/12.c6288509.jpg";